<template>
  <div>
    <b-row style="color:red;font-size:15pt;">
      이메뉴에 테스트필요 리뷰 <br/>
      api 전부 필요
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <h1>{{ $t('menu.user-reviews') }}</h1>
        <piaf-breadcrumb/>
        <div class="separator mb-5"/>
      </b-colxx>
    </b-row>

    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-row>
            <b-colxx xxs="12" md="6" lg="4" xl="3">
              <div class="form-group has-float-label">
                <b-input-group>
                  <v-date-picker
                    mode="single"
                    v-model="search.startDate"
                    :input-props="{ class:'form-control', placeholder: '시작일'  }"></v-date-picker>
                  <template v-slot:append>
                    <b-input-group-text>
                      <b-icon icon="calendar"></b-icon>
                    </b-input-group-text>
                  </template>
                </b-input-group>
                <span>등록시작일</span>
              </div>
            </b-colxx>
            <b-colxx xxs="12" md="6" lg="4" xl="3">
              <div class="form-group has-float-label">
                <b-input-group>
                  <v-date-picker
                    mode="single"
                    v-model="search.endDate"
                    :input-props="{ class:'form-control', placeholder: '종료일'  }"></v-date-picker>
                  <template v-slot:append>
                    <b-input-group-text>
                      <b-icon icon="calendar"></b-icon>
                    </b-input-group-text>
                  </template>
                </b-input-group>
                <span>등록종료일</span>
              </div>
            </b-colxx>
            <b-colxx xxs="12" md="6" lg="4" class="mb-3">
              <v-select v-model="search.replyKind" :reduce="item=>item.value"
                        label="label" placeholder="전체" :options="replyKindOptions" style="width:210px;"/>
            </b-colxx>
          </b-row>
          <b-row align-v="center" >
            <b-colxx xxs="9" md="6" lg="6">
              <b-input-group>
                <b-form-radio-group v-model="search.kind" @change="changeSearchKind">
                  <b-form-radio value="today">오늘</b-form-radio>
                  <b-form-radio value="yesterday">어제</b-form-radio>
                  <b-form-radio value="lastWeek">1주일전</b-form-radio>
                </b-form-radio-group>
                <b-button variant="primary default" size="sm" @click="searchData">검색하기</b-button>
              </b-input-group>
            </b-colxx>
            <b-colxx xxs="3" md="12" lg="6">
              <div class="float-md-right pt-1">
                <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-primary"
                            size="md">
                  <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">{{ size
                    }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </b-colxx>
          </b-row>

          <b-row class="m-3">
            <template v-if="isLoad">
              <b-table
                head-variant="light"
                ref="general-table"
                class="vuetable"
                selected-variant="primary"
                :items="reviews"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                primary-key="id"
                responsive
                show-empty
              >
                <template v-slot:table-colgroup>
                  <col style="min-width:100px"/>
                  <col style="min-width:300px"/>
                  <col style="min-width:500px"/>
                </template>
                <template v-slot:cell(a)="row">
                  <stars :value="row.item.a" :disabled="true"></stars>
                </template>
                <template v-slot:cell(c)="row">
                  <pre class="mt-3 mb-3">{{row.item.c}}</pre>
                  <b-row>
                    <b-colxx xxs="12">
                      <b-list-group flush class="mt-3 mb-3">
                        <b-list-group-item v-for="(cmt , idx) in row.item.comments" :key="cmt.id">
                          <b-row>
                            <b-colxx xxs="12" sm="1">
                              {{cmt.id}}
                            </b-colxx>
                            <b-colxx xxs="12" sm="7">
                              <span stype="white-space:pre;">{{cmt.comment}}</span>
                            </b-colxx>
                            <b-colxx xxs="12" sm="2">
                              <small class="text-muted">{{cmt.date}}</small>
                              <b-badge variant="outline-primary">{{cmt.writer}}</b-badge>
                            </b-colxx>
                            <b-colxx xxs="12" sm="1">
                              <b-button-group size="sm">
                                <b-btn variant="warning" @click="modifyComment(cmt)">
                                  <b-icon icon="pencil"></b-icon>
                                </b-btn>
                                <b-btn variant="danger" @click="deleteComent(cmt)">
                                  <b-icon icon="trash"></b-icon>
                                </b-btn>
                              </b-button-group>
                            </b-colxx>
                          </b-row>
                        </b-list-group-item>
                      </b-list-group>
                    </b-colxx>
                  </b-row>
                  <b-row>
                    <b-colxx sm="10">
                      <b-form-textarea v-model="row.item.replyComment"
                                       placeholder="리뷰에 대한 답변을 달아주세요."></b-form-textarea>
                    </b-colxx>
                    <b-colxx sm="2">
                      <b-button @click="onReply(row.item)" variant="primary default">답변저장</b-button>
                    </b-colxx>
                  </b-row>
                </template>

                <template v-slot:empty>
                  <h4 style="text-align:center">조회된 내용이 없습니다.</h4>
                </template>


              </b-table>

              <b-col>
                <b-pagination v-if="lastPage > 1"
                              size="sm"
                              align="center"
                              v-model="currentPage"
                              :total-rows="total"
                              :per-page="perPage">
                  <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                  </template>
                  <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                  </template>
                  <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                  </template>
                  <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                  </template>
                </b-pagination>
              </b-col>
            </template>
            <template v-else>
              <div class="loading"></div>
            </template>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import Stars from '../../components/Common/Stars'
  import api from '../../constants/api'
  import {alignTableCenter} from '../../utils'

  export default {
    components: {
      'v-select': vSelect,
      'stars': Stars
    },
    data() {
      return {
        isLoad: false,
        currentPage: 1,
        total: 0,
        pageSizes: [10, 20, 30],
        perPage: 10,
        lastPage: 0,
        replyKindOptions: [
          {label: '전체', value: null},
          {label: '답변미등록', value: 'noReply'}
        ],
        search: {
          startDate: new Date(),
          endDate: new Date(),
          kind: "today",
          replyKind: 'noReply'
        },
        fields: [
          {key: "a", label: '만족도', ...alignTableCenter},
          {key: "b", label: '작성일', ...alignTableCenter},
          {key: "c", label: '내용', thClass: "text-center align-middle"},
        ],
        reviews: [
          {
            id: 1, a: 3, b: '2020-03-03', c: "ssssssss", comments: [
              {id: 1, writer: '작성자', date: '2020-03-10', comment: '답글sssssssssasdfadfadfa'},
              {id: 2, writer: '성자', date: '2020-03-11', comment: '답글2'},
              {id: 3, writer: '자', date: '2020-03-02', comment: '답글3'},
            ]
          },
          {id: 2, a: 4, b: '2020-03-03', c: "ssssssss"},
          {id: 3, a: 3.5, b: '2020-03-03', c: "ssssssss"},
          {id: 4, a: 3, b: '2020-03-03', c: "ssssssss"},
          {id: 5, a: 3, b: '2020-03-03', c: "ssssssss"},
          {id: 6, a: 3, b: '2020-03-03', c: "ssssssss"},
        ]
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
      this.searchData()
    },
    methods: {
      searchData() {
        this.isLoad = false
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
        const params = {}

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
            this.reviews = res.data.data.content
            this.last = res.data.data.totalPages
            this.total = res.data.data.totalElements
            this.perPage = res.data.data.size

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);

        })

        this.isLoad = true
      },
      changePageSize(perPage) {
        this.perPage = perPage
      },
      changeSearchKind(value) {
        if (value === "today") {
          this.search.startDate = new Date()
          this.search.endDate = new Date()
        } else if (value === 'yesterday') {
          this.search.startDate = (d => new Date(d.setDate(d.getDate() - 1)))(new Date)
          this.search.endDate = new Date()
        } else {
          this.search.startDate = (d => new Date(d.setDate(d.getDate() - 7)))(new Date)
          this.search.endDate = new Date()
        }
      },
      onReply(item) {
        if (item.replyComment === undefined || item.replyComment.trim() === "") {
          alert('답변을 입력해주세요');
          return false
        } else {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
          const params = {}

          this.$http.get(reqURL, {
            params: params,
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {

            } else {
              throw 400
            }
          }).catch(err => {

          })

        }

      },
      deleteComent(comment) {

      },
      modifyComment(comment) {

      },
    }
    , watch: {
      'search.startDate': function () {
        this.search.kind = null
      },
      'search.endDate': function () {
        this.search.kind = null
      },
    }
  }
</script>
